import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { isChannel } from "@website/utils/channel/helpers";
import { numberConvert } from "@website/utils/number-convert";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { FooterRow } from "@website/widget/footer/footer-row";
import { applications, contactUs, copyright, snappSocialMediaLinks, socialMediaLinks, support } from "@website/widget/footer/footer.constants";
import { useFooter } from "@website/widget/footer/footer.hook";
import styles from "@website/widget/footer/footer.module.scss";
import { FooterPropertiesType } from "@website/widget/footer/footer.types";
import { FC } from "react";
export const FooterComponent: FC<FooterPropertiesType> = properties => {
  const $ = _c(45);
  const {
    minimalView,
    isShowSupportNumber: t0,
    isShowBolderPlateLinks: t1,
    hasB2BContact: t2,
    hasDownloadApp: t3
  } = properties;
  let t4;
  if ($[0] !== t0) {
    t4 = t0 === undefined ? !isChannel(["b2b", "telesale"]) : t0;
    $[0] = t0;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const isShowSupportNumber = t4;
  let t5;
  if ($[2] !== t1) {
    t5 = t1 === undefined ? !isChannel(["b2b", "telesale"]) : t1;
    $[2] = t1;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const isShowBolderPlateLinks = t5;
  let t6;
  if ($[4] !== t2) {
    t6 = t2 === undefined ? isChannel(["b2b", "telesale"]) : t2;
    $[4] = t2;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const hasB2BContact = t6;
  let t7;
  if ($[6] !== t3) {
    t7 = t3 === undefined ? !isChannel(["b2b", "snapp-ir", "telesale"]) : t3;
    $[6] = t3;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const hasDownloadApp = t7;
  const {
    certificates,
    links,
    moreInfo,
    services
  } = useFooter();
  let t8;
  if ($[8] !== isShowSupportNumber) {
    t8 = isShowSupportNumber && <FooterRow><div className={styles.support}><div className={styles["support-title"]}>پشتیبانی ۲۴ ساعته و ۷ روز هفته</div><div className={styles["support-phone"]}><a className={styles["support-phone-text"]} href={`tel:${support.phoneNumber.value}`}>{numberConvert(support.phoneNumber.text, {
              numberOnly: false,
              locale: "fa"
            })}</a><div className={styles["support-phone-icon"]}><MaterialIcon name="phone" /></div></div></div></FooterRow>;
    $[8] = isShowSupportNumber;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== isShowBolderPlateLinks || $[11] !== links || $[12] !== minimalView || $[13] !== moreInfo || $[14] !== services) {
    t9 = !minimalView && isShowBolderPlateLinks && <FooterRow><div className={styles.links}>{!isChannel(["snapp-ir"]) && <div className={styles["links-column"]}><div className={styles["links-column-title"]}>خدمات مسافرتی</div><div className={styles["links-column-list"]}>{services.map(_temp)}</div></div>}{!isChannel(["snapp-ir"]) && <div className={styles["links-column"]}><div className={styles["links-column-title"]}>امکانات</div><div className={styles["links-column-list"]}>{links.map(_temp2)}</div></div>}<div className={styles["links-column"]}><div className={styles["links-column-title"]}>اطلاعات بیشتر</div><div className={styles["links-column-list"]}>{moreInfo.map(_temp3)}</div></div></div></FooterRow>;
    $[10] = isShowBolderPlateLinks;
    $[11] = links;
    $[12] = minimalView;
    $[13] = moreInfo;
    $[14] = services;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className={styles["contact-us-title"]}>ارتباط با ما</div>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== hasB2BContact) {
    t11 = !hasB2BContact && <><div className={styles["contact-us-item"]}><div className={styles["contact-us-item-key"]}>آدرس</div><div className={styles["contact-us-item-value"]}>{isChannel(["snapp-ir"]) ? "\u062A\u0647\u0631\u0627\u0646\u060C \u0632\u0639\u0641\u0631\u0627\u0646\u06CC\u0647\u060C \u062E\u06CC\u0627\u0628\u0627\u0646 \u0634\u0647\u06CC\u062F \u0641\u0644\u0627\u062D\u06CC\u060C \u062A\u0642\u0627\u0637\u0639 \u062E\u06CC\u0627\u0628\u0627\u0646 \u0645\u0642\u062F\u0633 \u0627\u0631\u062F\u0628\u06CC\u0644\u06CC\u060C \u067E\u0644\u0627\u06A9 \u06F2" : "\u0628\u0644\u0648\u0627\u0631 \u0646\u0644\u0633\u0648\u0646 \u0645\u0627\u0646\u062F\u0644\u0627\u060C \u062A\u0642\u0627\u0637\u0639 \u0622\u0631\u0634 \u063A\u0631\u0628\u06CC\u060C \u0646\u0628\u0634 \u06A9\u0648\u0686\u0647 \u0627\u06CC\u0631\u062C\u060C \u067E\u0644\u0627\u06A9 \u06F1\u06F1\u06F5"}</div></div><div className={styles["contact-us-item"]}><div className={styles["contact-us-item-key"]}>کد پستی:</div><div className={styles["contact-us-item-value"]}>{numberConvert(contactUs.zipCode, {
            numberOnly: false,
            locale: "fa"
          })}</div></div><div className={styles["contact-us-item"]}><div className={styles["contact-us-item-key"]}>تلفن:</div><div className={styles["contact-us-item-value"]}><a href={`tel:${contactUs.phoneNumbers[0].value}`} itemScope={true}>{numberConvert(contactUs.phoneNumbers[0].text, {
              numberOnly: false,
              locale: "fa"
            })}</a>  -  <a href={`tel:${contactUs.phoneNumbers[1].value}`} itemScope={true}>{numberConvert(contactUs.phoneNumbers[1].text, {
              numberOnly: false,
              locale: "fa"
            })}</a>  ({numberConvert(contactUs.phoneNumberPrefix, {
            numberOnly: false,
            locale: "fa"
          })})</div></div></>;
    $[17] = hasB2BContact;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== hasB2BContact) {
    t12 = hasB2BContact && <><div className="text-on-surface-high-emphasis mt-1 flex items-center gap-4">پشتیبانی ۲۴ ساعته و ۷ روز هفته<a dir="ltr" href="tel:02192000123">۰۲۱ ۹۲۰۰۰۱۲۳ (داخلی ۳)</a></div><div className={styles["contact-us-item"]}><div className={styles["contact-us-item-key"]}>آدرس:</div><div className={styles["contact-us-item-value"]}>{isChannel(["snapp-ir"]) ? "\u062A\u0647\u0631\u0627\u0646\u060C \u0632\u0639\u0641\u0631\u0627\u0646\u06CC\u0647\u060C \u062E\u06CC\u0627\u0628\u0627\u0646 \u0634\u0647\u06CC\u062F \u0641\u0644\u0627\u062D\u06CC\u060C \u062A\u0642\u0627\u0637\u0639 \u062E\u06CC\u0627\u0628\u0627\u0646 \u0645\u0642\u062F\u0633 \u0627\u0631\u062F\u0628\u06CC\u0644\u06CC\u060C \u067E\u0644\u0627\u06A9 \u06F2" : "\u0628\u0644\u0648\u0627\u0631 \u0646\u0644\u0633\u0648\u0646 \u0645\u0627\u0646\u062F\u0644\u0627\u060C \u062A\u0642\u0627\u0637\u0639 \u0622\u0631\u0634 \u063A\u0631\u0628\u06CC\u060C \u0646\u0628\u0634 \u06A9\u0648\u0686\u0647 \u0627\u06CC\u0631\u062C\u060C \u067E\u0644\u0627\u06A9 \u06F1\u06F1\u06F5"}</div></div></>;
    $[19] = hasB2BContact;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = <div className={styles["contact-us"]}>{t10}{t11}{t12}</div>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className={styles["social-media-title"]}>شبکه های اجتماعی</div>;
    t15 = <div className={styles["social-media-description"]}>با ما در ارتباط باشید</div>;
    $[24] = t14;
    $[25] = t15;
  } else {
    t14 = $[24];
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className={styles["social-media"]}>{t14}{t15}<div className={styles["social-media-list"]}>{(isChannel(["snapp-ir"]) ? snappSocialMediaLinks : socialMediaLinks).map(_temp4)}</div></div>;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t13) {
    t17 = <FooterRow><div className={styles.contact}>{t13}{t16}</div></FooterRow>;
    $[27] = t13;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== hasDownloadApp || $[30] !== minimalView) {
    t18 = !minimalView && hasDownloadApp && <FooterRow><div className={styles["download-app"]}><div className={styles["download-app-content"]}><div className={styles["download-app-title"]}>دانلود اپلیکیشن</div></div><div className={styles["download-app-list"]}>{applications.map(_temp5)}<a href="https://www.snapptrip.com/" className="flex h-[48px] w-[161px] items-center justify-between rounded-md bg-[#0C0D10] px-3 py-0" rel="nofollow"><p className="text-extra-caption text-[#fff]">نسخه وب اپلیکیشن</p><div className="text-[16px] font-bold text-[#FFF]">PWA</div></a><a className="hidden md:block" href="/apps"><Button className="!bg-on-surface-medium-emphasis !h-[48px] !w-[48px]" size="large" variant="contained" color="neutral" StartIcon={<MaterialIcon name="chevron_left" />} /></a></div></div></FooterRow>;
    $[29] = hasDownloadApp;
    $[30] = minimalView;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className={styles["about-us-title"]}>{replaceSnappTripBasedOnChannel("\u062F\u0631\u0628\u0627\u0631\u0647 \u06CC \u0627\u0633\u0646\u067E \u062A\u0631\u06CC\u067E")}</div>;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className={styles["about-us-content"]}>{t19}<div className={styles["about-us-description"]}>{replaceSnappTripBasedOnChannel("\u062F\u0631 \u0627\u0633\u0646\u067E \u062A\u0631\u06CC\u067E \u0628\u0627 \u0686\u0646\u062F \u06A9\u0644\u06CC\u06A9 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u06CC\u062F \u067E\u0631\u0648\u0627\u0632\u0647\u0627 \u0648 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627\u06CC \u0645\u062E\u062A\u0644\u0641 \u0631\u0627 \u0628\u0631\u0631\u0633\u06CC \u06A9\u0631\u062F\u0647 \u0648 \u0628\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u0645\u0646\u0627\u0633\u0628\u200C\u062A\u0631\u06CC\u0646 \u06AF\u0632\u06CC\u0646\u0647\u200C\u0647\u0627 \u0633\u0641\u0631 \u062E\u0648\u0634\u06CC \u0631\u0627 \u062A\u062C\u0631\u0628\u0647 \u06A9\u0646\u06CC\u062F.")}</div></div>;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== certificates) {
    t21 = certificates.map(_temp6);
    $[34] = certificates;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t21) {
    t22 = <FooterRow><div className={styles["about-us"]}>{t20}<div className={styles["about-us-list"]}>{t21}</div></div></FooterRow>;
    $[36] = t21;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <FooterRow background="gray"><div className={styles.copyright}><div className={styles["copyright-item"]}>از مطالب این وب‌سایت فقط می‌توانید برای مقاصد غیرتجاری و با ذکر منبع استفاده کنید.{!isChannel(["snapp-ir"]) && " \u062A\u0645\u0627\u0645\u06CC \u062D\u0642\u0648\u0642 \u0627\u06CC\u0646 \u0648\u0628\u200C\u0633\u0627\u06CC\u062A \u0628\u0647 \u0634\u0631\u06A9\u062A \u0622\u0631\u0627 \u062C\u0647\u0627\u0646 \u0646\u0648\u06CC\u0646 \u06AF\u0633\u062A\u0631 \u0627\u0637\u0644\u0633 \u062A\u0639\u0644\u0642 \u062F\u0627\u0631\u062F."}</div><div className={styles["copyright-item"]} suppressHydrationWarning={true}>{copyright.sign}</div></div></FooterRow>;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== t17 || $[40] !== t18 || $[41] !== t22 || $[42] !== t8 || $[43] !== t9) {
    t24 = <footer className={styles.footer}>{t8}{t9}{t17}{t18}{t22}{t23}</footer>;
    $[39] = t17;
    $[40] = t18;
    $[41] = t22;
    $[42] = t8;
    $[43] = t9;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  return t24;
};
function _temp(item) {
  return <a className={styles["links-column-item"]} href={item.url} key={item.url}>{item.title}</a>;
}
function _temp2(item_0) {
  return <a className={styles["links-column-item"]} href={item_0.url} itemScope={true} key={`${item_0?.title}-${item_0?.url}`} {...item_0.nofollow && {
    rel: "nofollow"
  }}>{item_0.title}</a>;
}
function _temp3(item_1) {
  return <a className={styles["links-column-item"]} href={item_1.url} itemScope={true} key={item_1?.url}>{item_1.title}</a>;
}
function _temp4(item_2) {
  return <Button EndIcon={item_2.icon} aria-label={item_2.ariaLabel} className={styles["social-media-item"]} color="neutral" equalDimension={true} href={item_2.url} key={item_2.url} rel={item_2.rel} role="link" size="x-small" target="_blank" variant="text" />;
}
function _temp5(item_3) {
  return <a className={styles["download-app-item"]} href={item_3?.url} itemScope={true} key={item_3?.url} rel="noreferrer nofollow" target="_blank">{item_3?.image && <LazyImage alt={item_3?.alt} height={item_3?.height} loading="lazy" src={item_3?.image} width={item_3?.width} />}</a>;
}
function _temp6(item_4) {
  return <div className={styles["about-us-item"]} itemScope={true} key={item_4?.id}>{item_4?.src && <LazyImage {...item_4} />}</div>;
}